module.exports = __webpack_public_path__ + "img/222@2x.14a5bdb8.png";